import angular from 'angular';
import constants from 'app/constants';
import activeAgenda from './activeAgenda';
// import completedAudit from './completedAudit';
import directive from './agendas.directive';

// export { default as auditUniqueNameValidator } from './messages/audit-unique-name.validator.directive';

export default angular.module('app.components.advisory.oversight.agendas', [
  activeAgenda,
  // completedAudit,
  constants,
])
  .directive('agendas', directive)
  .name;

console.log('app.components.advisory.oversight.agendas created');
